export default function phoneValid(phoneNumber) {
    // Regular expression for phone number validation (supports common formats)
    //below regex code checks 1st digit for stating with (6, 7, 8, 9) and make sure next 9
    //digits to be number
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phoneNumber);
}
